import _typeof from "E:/workspace/hw/moment-vue-h5-new/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date;
  if (_typeof(time) === 'object') {
    date = time;
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  var time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, function (result, key) {
    var value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  var d = new Date(time);
  var now = Date.now();
  var diff = (now - d) / 1000;
  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  var search = url.split('?')[1];
  if (!search) {
    return {};
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"').replace(/\+/g, ' ') + '"}');
}
function getSystemOsType() {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端

  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端

  if (isAndroid) {
    return 'android';
  } else if (isiOS) {
    return 'ios';
  } else {
    return '';
  }
}

// 获取用户信息
export function getUserIdAndRealName(actionName, callback) {
  try {
    window.uploadUserIdAndRealNameMR = function (userId, realName) {
      // ostype === 'ios' ? (window.setUserInfoFromClient  = null) : ''
      callback(userId, realName);
    };
  } catch (error) {
    alert(error);
  }
  try {
    if (getSystemOsType() == 'android') {
      verifyJsBridge.postNotification(actionName, JSON.stringify({}));
    } else {
      window.webkit.messageHandlers[actionName].postMessage({});
    }
  } catch (error) {
    alert(error);
  }
}

// 返回上一级
export function returnBack(actionName) {
  try {
    if (getSystemOsType() == 'android') {
      verifyJsBridge.postNotification(actionName, JSON.stringify({}));
    } else {
      window.webkit.messageHandlers[actionName].postMessage({});
    }
  } catch (error) {
    alert(error);
  }
}
export function getUrlParam(name) {
  var url = document.location.toString();
  var arrObj = url.split('?');
  var params = Object.create(null);
  if (arrObj.length > 1) {
    arrObj = arrObj[1].split('&');
    arrObj.forEach(function (item) {
      item = item.split('=');
      params[item[0]] = item[1];
    });
  }
  return params[name];
}
export function getUrlParamByName(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)'); // 构造一个含有目标参数的正则表达式对象
  var r = window.location.href.substr(1).match(reg); // 匹配目标参数
  if (r != null) {
    return unescape(r[2]);
  } else {
    return null; // 返回参数值
  }
}